import _createClass from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";

/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */
// @ts-nocheck
var MediaDeviceInfoShim = /*#__PURE__*/_createClass(function MediaDeviceInfoShim(options) {
  _classCallCheck(this, MediaDeviceInfoShim);

  Object.defineProperties(this, {
    deviceId: {
      get: function get() {
        return options.deviceId;
      }
    },
    groupId: {
      get: function get() {
        return options.groupId;
      }
    },
    kind: {
      get: function get() {
        return options.kind;
      }
    },
    label: {
      get: function get() {
        return options.label;
      }
    }
  });
});

export default MediaDeviceInfoShim;